document.getElementById('startButton').addEventListener('click', function() {
  // Hide the controls
  document.getElementById('controls').style.display = 'none';

  // Show the dot
  const dot = document.getElementById('dot');
  dot.style.display = 'block';

  // Get the selected duration
  const duration = document.getElementById('duration').value;

  // Start the timer
  setTimeout(function() {
    dot.style.display = 'none';

    // Show the message
    const message = document.getElementById('message');
    message.style.display = 'block';

    // Hide the message after 2 seconds
    setTimeout(function() {
      message.style.display = 'none';
    }, 2000);
  }, duration);
});
